/* eslint-disable react/jsx-key */
/* eslint-disable react/display-name */
import React, { forwardRef, LegacyRef, useEffect, useState } from "react";

type DropdownProps = {
  title?: string;
  titleClassName?: string;
  placeholder?: string;
  highlightText?: string;
  isScrollable?: boolean;
  labelList: any[]; //string or ReactNode //화면에 보이는 용으로만 쓰임
  itemList: any[]; //실제 값이 바뀌는 용(labelList와 같은 index)
  selectedLabelList?: any[]; //선택된 label이 화면에 보이는 용도(labelList와 같은 index)
  isClicked: boolean;
  setIsClicked: React.Dispatch<React.SetStateAction<boolean>>;
  select: any; //itemList에 있는 값 중 하나
  setSelect: React.Dispatch<React.SetStateAction<any>> | ((item: any) => void);
  selectedDropDownItemClassName?: string;
  dropdownOptionsClassName?: string;
  removedClickTargetId?: string;
};

// https://www.figma.com/design/xnr558XUCXb4vkBy6eAif7/%5B%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC%5D-Potoo-Library?node-id=200-1728&t=3lunUvpzgaQBTI5S-4
const Dropdown = forwardRef((props: DropdownProps, ref: LegacyRef<HTMLDivElement>) => {
  const {
    title,
    titleClassName,
    placeholder = "선택하기",
    highlightText = "",
    isScrollable = false,
    labelList = [],
    selectedLabelList,
    itemList,
    isClicked,
    setIsClicked,
    select,
    setSelect,
    selectedDropDownItemClassName,
    dropdownOptionsClassName = "",
    removedClickTargetId,
  } = props;

  //-1: 선택하기
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);

  useEffect(() => {
    // console.log("itemListew", itemList);
    //console.log("labelList", labelList);
    //console.log("select", select);
    for (let i = 0; i < itemList?.length; i++) {
      if (select === itemList[i]) {
        setSelectedIndex(i);
        return;
      }
    }
  }, [select, itemList]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        textAlign: "start",
        gap: "8px",
        width: "100%",
      }}
      ref={ref}
    >
      {title !== "" && <span className={`body1-700 gray-600 ${titleClassName}`}>{title}</span>}

      <div className="dropdown">
        <button
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            const target = e.target as HTMLElement;
            if (target.id === removedClickTargetId) {
              //removedClickTargetId가 눌린 거라면 드롭다운이 켜지지 않도록 제어
              return;
            }
            setIsClicked(!isClicked);
          }}
          className={`background-white ${selectedIndex === -1 || select === undefined || select === "" ? "gray-500" : "gray-3 "}
            ${isClicked === true ? " clicked-dropdown-btn" : " "}`}
          style={{ width: "100%" }}
        >
          {selectedIndex === -1 || select === undefined || select === ""
              ? props.highlightText ? (
                <span>
                  {placeholder.split(props.highlightText).map((part, i, array) => (
                    <React.Fragment key={i}>
                      {part}
                      {i < array.length - 1 && <span className="violet-500">{props.highlightText}</span>}
                    </React.Fragment>
                  ))}
                </span>
              ) : placeholder
            : selectedLabelList
              ? selectedLabelList[selectedIndex]
              : labelList[selectedIndex]}
          <i
            className={isClicked === true ? "icon-icon-disclosure-up" : "icon-icon-disclosure-down"}
            style={{ fontSize: "24px" }}
          />
        </button>

        <div
          className={`dropdown-options 
                    ${isScrollable === true ? "dropdown-scrollable " : " "}
                    ${isClicked === true ? "clicked-dropdown-options " : " "}
                    ${dropdownOptionsClassName}
                    `}
        >
          {itemList?.map((item, index) => (
            <DropDownItem
              key={`dropdown-${index}`}
              label={labelList[index]}
              isSelected={select === item}
              onSelect={() => {
                setSelectedIndex(index);
                setSelect(item);
              }}
              setIsClicked={setIsClicked}
              selectedDropDownItemClassName={selectedDropDownItemClassName}
            ></DropDownItem>
          ))}
        </div>
      </div>
    </div>
  );
});

type DropDownItemProps = {
  label: string;
  isSelected: boolean;
  onSelect: () => unknown;
  setIsClicked: React.Dispatch<React.SetStateAction<boolean>>;
  selectedDropDownItemClassName?: string;
};

const DropDownItem = (props: DropDownItemProps) => {
  const { label, isSelected, onSelect, setIsClicked, selectedDropDownItemClassName } = props;

  return (
    <button
      className={`dropdown-item-btn 
        ${isSelected ? ` selected-dropdown-item-btn ${selectedDropDownItemClassName}` : " "}`}
      onClick={() => {
        onSelect();
        setIsClicked(false);
      }}
      style={{ width: "100%" }}
    >
      {label}
    </button>
  );
};

export { Dropdown };
